import { gql, TypedDocumentNode } from '@apollo/client';

export const GET_WEBSITE_INFORMATION: TypedDocumentNode<{ getWebsiteInformation: { numberOfUsers: number } }> = gql`
  query getInformation {
    getWebsiteInformation {
      numberOfUsers
    }
  }
`;
